(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["house-aura555"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aura-door-carousel')) {
    customElements.define('aura-door-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('[data-carousel-track], .aura-house__doors');
        const controls = this.querySelector('.aura-house__carousel-controls');
        if (!track || !controls) return;
        if (track.matches('[data-carousel-track]') && !track.dataset.shuffled && !window.Shopify?.designMode) {
          const cards = [...track.querySelectorAll('.aura-house__product')];
          const pinned = this.id === 'aura-produtos' ? cards.find(card => card.dataset.productId === '10535775535406') : null;
          const others = cards.filter(card => card !== pinned);
          for (let i = others.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [others[i], others[j]] = [others[j], others[i]];
          }
          try {
            const key = 'aura-gift-first-' + this.id;
            if (others.length > 1 && others[0].dataset.productId === sessionStorage.getItem(key)) others.push(others.shift());
            if (others[0]) sessionStorage.setItem(key, others[0].dataset.productId);
          } catch {}
          if (pinned) track.append(pinned);
          others.forEach(card => track.append(card));
          track.dataset.shuffled = 'true';
          track.scrollLeft = 0;
        }
        const buttons = [...controls.querySelectorAll('button')];
        const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          buttons[0].disabled = track.scrollLeft <= 5;
          buttons[1].disabled = track.scrollLeft >= max - 2;
          controls.hidden = max <= 2;
        };
        const step = (direction) => {
          const card = track.firstElementChild;
          if (!card) return;
          const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
          track.scrollBy({ left: direction * distance, behavior: behavior() });
        };
        buttons.forEach(button => button.addEventListener('click', () => step(Number(button.dataset.doorStep)), options));
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: behavior() });
          } else step(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        let drag = null;
        let suppressClick = false;
        track.addEventListener('dragstart', event => event.preventDefault(), options);
        track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          suppressClick = false;
          drag = { x: event.clientX, left: track.scrollLeft, id: event.pointerId, moved: false };
        }, options);
        track.addEventListener('pointermove', event => {
          if (!drag) return;
          const distance = event.clientX - drag.x;
          if (!drag.moved && Math.abs(distance) < 7) return;
          if (!drag.moved) track.setPointerCapture(drag.id);
          drag.moved = true;
          suppressClick = true;
          track.classList.add('is-dragging');
          track.scrollLeft = drag.left - distance;
        }, options);
        const finishDrag = () => {
          if (!drag) return;
          if (track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
          drag = null;
          track.classList.remove('is-dragging');
        };
        track.addEventListener('pointerup', finishDrag, options);
        track.addEventListener('pointercancel', finishDrag, options);
        track.addEventListener('pointerleave', () => { if (drag && !drag.moved) finishDrag(); }, options);
        track.addEventListener('click', event => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        }, { ...options, capture: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
